/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-10-20 11:22:40
 */

import React, { Component } from "react";
import moment from "moment";


class Slot extends Component {
  
  defaultLanguage = window["app-config"].defaultLang;
  color = window["app-config"].ui.slotScreen;
  

  render() {
    return (
      <div className="sl__modal_calendar-col">
        <div
          id="day1"
          className="sl__modal_calendar--title slotdate"
          date={`${moment(this.props.date, "MM-DD-YYYY").format(
            "DD-MMM-YYYY"
          )}`}
        >
          {moment(this.props.date, "MM-DD-YYYY").format("DD-MMM-YYYY")}
        </div>
        <div className="sl__modal_calendar--timeselection">
          <div className="sl__modal_calendar--timeselection-wrapper">
            <div
              id="day1container"
              className="sl__modal_calendar--timeselection-inner"
            >
              {this.props.timeSlots.length === 0 ? (
                <div className="no-slot" style={{ cursor: "default" }}>
                  {this.props.lang.NoSlot}
                </div>
              ) : (
                this.props.timeSlots.map((data, index) => {
                  return (
                    <div
                      className="time"
                      key={index}
                      value={data.SlotID}
                      time={data.StartTime}
                    >
                      {data.StartTime}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Slot;
